import { Text } from '@chakra-ui/react';
import React from 'react';

const SectionBodyText = ({ children }) => {
    return (
        <Text fontSize={20}>{children}</Text>
    );
};

export default SectionBodyText;